<div *ngIf="showButtons" #fixedElements class="fixed-elements">
    <div *ngIf="isShow" [@enterAnimation] class="mb-2">
        <div (click)="gotoTop()" class="go-to-top bg-white shadow">
            <svg-icon src="assets/images/icon-chevron-up.svg"></svg-icon>
        </div>
    </div>

    <div *ngIf="!(overlays$ | async).chat && (isShowChat || showChatInitially && (!(user$ |async) || (user$ |async) && (user$ |async).guest === 0 && (user$ |async).blacklisted === 0))" [@enterAnimation] class="quickChatTrigger shadow" (click)="triggerQuickChat()">
        <div class="badge-count" *ngIf="(chatStore$ | async).unread">{{(chatStore$ | async).unread}}</div>

        <svg-icon src="assets/images/icon-chat-message.svg"></svg-icon>
    </div>
</div>
